module.exports = __webpack_public_path__ + "static/9i-e8d920f5bf6dea0b9fe56768c15fdffd.woff";